import "./LoginPage.css";
import FormLogin from "../../Component/form_login/formLogin";

function LoginPage() {
  return (
    <div className="login-page">
      <FormLogin />
    </div>
  );
}

export default LoginPage;

